import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import { useDispatch } from 'react-redux';

import { campaignTypes } from 'constants/campaigns';
import dashboardStructure from 'features/views/campaignDashboards/structure';
import { currency, equalOrThreeDashes, percentage } from 'utils';

const { views } = dashboardStructure.constants;

const getName = (manager) => `${manager.surname || ''} ${manager.firstName || ''}`.trim();

export const ManagersTableRow = ({ manager = {}, campaignType }) => {
	const dispatch = useDispatch();

	const handleViewChange = useCallback(() => {
		const { orgStructure = {}, campaign = {} } = manager;

		dispatch(
			dashboardStructure.actions.changeView({
				view: views.MANAGER,
				contextUser: orgStructure.manager,
				campaignId: campaign.id,
				structures: [
					{
						channelId: orgStructure.channelId,
						regionId: orgStructure.regionId,
						agencyIds: [orgStructure.agencyId],
						manager: orgStructure.manager.login,
					},
				],
			}),
		);
	}, [dispatch, manager]);

	const {
		addMatFulfillment,
		notDone,
		progress,
		actualReplacement,
		production,
		planFulfillment,
		orgStructure = {},
	} = manager;

	return (
		<>
			<TableCell>
				<Link underline="none" onClick={handleViewChange} sx={{ cursor: 'pointer' }}>
					{equalOrThreeDashes(getName(orgStructure.manager))}
				</Link>
			</TableCell>
			<TableCell>{equalOrThreeDashes(progress)}</TableCell>
			<TableCell>{equalOrThreeDashes(notDone)}</TableCell>
			<TableCell>{equalOrThreeDashes(percentage(addMatFulfillment))}</TableCell>
			{campaignType === campaignTypes.UP_SELL && (
				<TableCell>{equalOrThreeDashes(percentage(actualReplacement))}</TableCell>
			)}
			<TableCell>
				{currency(production)} / {percentage(planFulfillment)}
			</TableCell>
		</>
	);
};

ManagersTableRow.propTypes = {
	campaignType: PropTypes.number,
	manager: PropTypes.object,
};

export default ManagersTableRow;
